import type { Config } from "tailwindcss";
import defaultTheme from "tailwindcss/defaultTheme";

function getMaxWidth() {
  const extendedMaxWidthFromWidth: any = {};

  if (defaultTheme.width) {
    for (const [key, value] of Object.entries(defaultTheme.width)) {
      extendedMaxWidthFromWidth[key] = value;
    }
  }

  return extendedMaxWidthFromWidth;
}

// console.log("defaultTheme", defaultTheme.fontFamily.sans);

export default {
  content: ["./src/**/*.{js,jsx,ts,tsx}"],
  theme: {
    screens: {
      xs: "450px",
      ...defaultTheme.screens,
    },
    extend: {
      fontFamily: {
        ...defaultTheme.fontFamily,
        sans: ["Montserrat", ...(defaultTheme.fontFamily?.sans ?? [])],
      },
      borderColor: {
        DEFAULT: "#000",
      },
      aspectRatio: {
        link: "auto 480 / 250",
      },
      height: {
        "screen-4/5": "80vh",
      },
      maxWidth: getMaxWidth(),
    },
  },
} satisfies Config;
